import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MassMessageV2 from './index';
import MassMessageLegacy from '../../../../components/Routes/Reports/MassMessage';

const MassMessageReportGate = props => {
  const flags = useFlags();
  if (flags.events) return <MassMessageV2 {...props} />;
  return <MassMessageLegacy {...props} />;
};

export default MassMessageReportGate;
